<template>
    <div class="">
       <h1>hola mundo!</h1>
    </div>
</template>
<script>

    export default {
        name: 'sse_pruebas',
    }
</script>
<style lang="scss">

</style>